/**
 * ProjectDataContext
 *
 * Centralise l'appel à useOdooData pour éviter les appels API dupliqués
 * entre App.jsx, Dashboard, HelpdeskPage, ClientTestingPage, UserStoriesByStatusPage.
 */

import React, { createContext, useContext, useState, useEffect } from 'react';
import { useOdooData } from '../hooks/useOdooData';
import { useAuth } from './AuthContext';

const ProjectDataContext = createContext(null);

export const ProjectDataProvider = ({ children }) => {
  const { user } = useAuth();

  // Ne lire le projectId que si l'utilisateur est authentifié
  // Evite les appels API prématurés avant le login qui causent des 401
  const projectId = user && typeof localStorage !== 'undefined'
    ? parseInt(localStorage.getItem('selected_project_id'))
    : null;

  const [, setProjectRevision] = useState(0);
  useEffect(() => {
    const update = () => setProjectRevision(value => value + 1);
    window.addEventListener('active-project-change', update);
    return () => window.removeEventListener('active-project-change', update);
  }, []);

  const data = useOdooData(projectId, null);

  return (
    <ProjectDataContext.Provider value={data}>
      {children}
    </ProjectDataContext.Provider>
  );
};

export const useProjectData = () => {
  const context = useContext(ProjectDataContext);
  if (!context) {
    throw new Error('useProjectData must be used within a ProjectDataProvider');
  }
  return context;
};
